import Icon from "components/icon";
import styled from "@emotion/styled";
import { Colors } from "theme/colors";
import { fontQuicksand } from "theme/fonts";

export const StyledWrapper = styled.div`
  height: 23.53rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledIcon = styled(Icon)`
  font-size: 4.25rem;
  color: ${Colors.BLUE};
`;

export const StyledText = styled.div`
  margin-top: 5rem;
  color: ${Colors.BLUE};
  ${fontQuicksand()};
  font-size: 1.88rem;
`;
